import React, { useState } from 'react';
import { useLanguage } from '../../../context/LanguageContext';
import { useLocation, useNavigate } from 'react-router-dom';
import { unassignHub } from '../../../api/api_hubs';
import { updateSpace } from '../../../api/api_spaces';
import { ResponsiveTitle } from '../../Entities/ResponsiveText';

const EditSpace = () => {
    const { translations } = useLanguage();
    const location = useLocation();
    const { space } = location.state;
    const [spaceName, setSpaceName] = useState(space.name);
    const [hubs, setHubs] = useState(space.hubs);
    const navigate = useNavigate();
    const [visiblePotId, setVisiblePotId] = useState(null);

    const handleSave = async () => {
        const token = localStorage.getItem('userToken');
        const updatedSpace = { name: spaceName, user_id: space.user_id };
        const response = await updateSpace(space.id, updatedSpace, token);

        if (response) {
            alert(translations.space_updated_successfully);
            navigate('/spaces/spaceManager');
        } else {
            alert(translations.failed_to_update_space);
        }
    };

    const handleDelete = async (hubId) => {
        const token = localStorage.getItem('userToken');
        if (window.confirm(translations.confirm_delete_hub)) {
            const response = await unassignHub(hubId, token);
            if (response && !response.error) {
                setHubs(prevHubs => prevHubs.filter(hub => hub.id !== hubId));
            } else {
                alert(translations.failed_to_delete_hub);
            }
        }
    };

    const togglePotVisibility = (hubId) => {
        setVisiblePotId(prevId => prevId === hubId ? null : hubId);
    };

    const handleEditHub = (hub) => {
        navigate(`editHub/${hub.SN}`, { state: { hub } });
    };

    const handleAddHub = () => {
        navigate(`newHub`, { state: { space } });
    };

    const handleBack = () => {
        navigate('/spaces/spaceManager');
    };

    return (
        <div className="sm-page">
            <div className="sm-container">
                <div className="header">
                    <button onClick={handleBack} className="back-button">&#8592;</button>
                    <h1>{translations.edit_space}</h1>
                    <button className="header-button" onClick={handleAddHub}>{translations.add_hub}</button>
                </div>
                <div className="content">
                    <span className="label">{translations.name}</span>
                    <input
                        type="text"
                        className="sm-input"
                        value={spaceName}
                        onChange={(e) => setSpaceName(e.target.value)}
                    />
                    <div className="sm-space-list">
                        {hubs && (
                            <div className="sm-hub-list">
                                <div className="sm-space-info">
                                    {hubs.map(hub => (
                                        <li
                                            key={hub.id}
                                            className="sm-space-container"
                                            onClick={() => togglePotVisibility(hub.id)}
                                        >
                                            <div className="sm-space-header">
                                                <ResponsiveTitle text={hub.name} style={{ flex: 1 }} className="sm-space-info-title" />
                                                <button
                                                    onClick={(e) => { e.stopPropagation(); handleEditHub(hub); }}
                                                    className="general-button edit-button sm-button"
                                                >
                                                    <i className="fi fi-rr-pencil"></i>
                                                </button>
                                                <button
                                                    onClick={(e) => { e.stopPropagation(); handleDelete(hub.id); }}
                                                    className="general-button delete-button sm-button"
                                                >
                                                    <i className="fi fi-rr-trash"></i>
                                                </button>
                                            </div>
                                            <div>
                                                <span>{translations.SN}: {hub.SN}</span>
                                            </div>
                                            <div>
                                                <span>
                                                    {translations.irrigation_system}: {hub.irrigation_system_enabled ? translations.active : translations.disabled}
                                                </span>
                                            </div>
                                            <div>
                                                {hub.pots && hub.pots.length > 0 ? (
                                                    <button
                                                        onClick={(e) => { e.stopPropagation(); togglePotVisibility(hub.id); }}
                                                        className="sm-space-info-button"
                                                    >
                                                        {translations.pots} {visiblePotId === hub.id ? '↑' : '↓'}
                                                    </button>
                                                ) : (
                                                    <span>{translations.no_pots}</span>
                                                )}
                                            </div>
                                            {visiblePotId === hub.id && hub.pots && (
                                                <ul className="sm-sensor-list">
                                                    {hub.pots.map(pot => (
                                                        <li key={pot.id} className="sm-sensor-info">
                                                            {pot.name}
                                                        </li>
                                                    ))}
                                                </ul>
                                            )}
                                        </li>
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
                <div className="content">
                    <button onClick={handleSave} className="general-button">{translations.save}</button>
                </div>
            </div>
        </div>
    );
};

export default EditSpace;
